import { RG_TYPE } from '../../types/rg-type.js';

const DefaultRoof = {
    type: RG_TYPE.Roof,
    size: [3, 0.1, 3],
    anchor: [0.5, 1, 0.5],
    pos: [0, 1, 0],
    name: 'roof',
    color: '#C9D8D7',
    children: []
};

export { DefaultRoof };
//# sourceMappingURL=default-roof.js.map
